var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-overlay',{attrs:{"show":_vm.showToast},on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"toast"},[_c('img',{staticClass:"img",attrs:{"src":require("@/assets/images/guide/showtoast.png"),"alt":""}}),_c('div',{staticClass:"button",on:{"click":_vm.clkClose}},[_vm._v("好的，我知道了")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }